export default "__VITE_ASSET__rX2q2agv__"